import { useFollows } from "../lib/follows-context";
import styles from "./FollowButton.module.css";

interface FollowButtonProps {
  installName: string;
  /** Name used in the confirmation toast. */
  name: string;
}

/**
 * Follow / Following toggle. Renders nothing while the flag is off or for the caller's own
 * items. stopPropagation keeps a
 * click inside a clickable card or table row from also opening its detail page.
 */
export default function FollowButton({ installName, name }: FollowButtonProps) {
  const { enabled, isFollowing, isOwn, toggle } = useFollows();
  if (!enabled || isOwn(installName)) return null;

  const following = isFollowing(installName);
  return (
    <button
      type="button"
      aria-pressed={following}
      aria-label={`Follow ${name}`}
      className={following ? styles.following : styles.follow}
      onClick={(event) => {
        event.stopPropagation();
        event.preventDefault();
        void toggle(installName, name, !following);
      }}
    >
      {following ? "Following" : "Follow"}
    </button>
  );
}
